import React from 'react';
import { Icon } from './Icon.js';
export const IconAlign3TopFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("rect", { x: "2", y: "2", width: "6", height: "14", rx: "2.25", ry: "2.25", fill: "currentColor" }),
        React.createElement("rect", { x: "10", y: "2", width: "6", height: "8", rx: "2.25", ry: "2.25", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconAlign3TopFill18.js.map